import { useEffect } from 'react';

/** Hook for changing title */
export const useTitle = (title: string) => {
  useEffect(() => {
    const oldTitle = document.title;
    title && (document.title = title);
    return () => {
      document.title = oldTitle
    };
  }, [title]);
};